import React from "react";
// import G2 from '@antv/g2';
//import { Chart } from 'primereact/components/chart/Chart';
import { withTheme } from "styled-components";
import ChartJSLabel from "chartjs-plugin-datalabels";
import { Pie } from "react-chartjs-2";
import { VerticalMiddleContainer } from "../layout/Layout";
import { path, equals } from "ramda";
import DataSet from "@antv/data-set";
import { isFunction, ArrayUtil } from "../../util";
import { DataVisualizeKeys } from "../../theme/Colors";
import ColorUtil from "../../util/ColorUtil";
import { Metrics } from "../../theme";

class PieChart extends React.Component {
    _lastData = [];
    mutateData = {};
    chart = null;
    constructor(props){
    	super(props);
    	this.createData(props);
    }
    componentWillReceiveProps(props){
    	this.createData(props);
    }
    createData(props){
    	const { chart_id, 
    		data, 
    		labelKey, valueKey,
    		onClick,
    		theme,
    		visualColorKey,
    		hideZero,
    	} = props;
    	const labels = [];
    	const values = [];
    	const borderWidths = [];
    	const datasets = {
    		labels:[],
    	};
    	data.forEach((e,i)=>{
    		if(hideZero){
    			if(e[valueKey]>0){
    				labels.push(e[labelKey]);
    				values.push(e[valueKey]);
    				borderWidths.push(0);
    			}
    		}else{
    			labels.push(e[labelKey]);
    			values.push(e[valueKey]);
    			borderWidths.push(0);
    		}
    	});
    	this.mutateData = {
    		sum: values.length > 0 ? values.reduce((c,v)=>c+v) : 1,
    		labels,
    		datasets:[{
    			data:values,
    			borderWidth:borderWidths,
    			backgroundColor:ColorUtil.generateVisualColorOfSize(theme, visualColorKey, data.length)
    		}]
    	};
    	this._lastData = data;
    }
    onItemClick = (e, active)=>{
    	if(ArrayUtil.isAliveArray(active, true)){
    		const { data, onClick } = this.props;
    		const { _index } = active[0];
    		if(isFunction(onClick)){
    			setTimeout(()=>{
    				onClick(data[_index]);
    			}, Metrics.chart.onClickDelay);
    		}
    	}
    }
    shouldComponentUpdate(nextProps, nextState){
    	return !equals(this._lastData, nextProps.data);
    }
    render(){
    	const { visualColorKey, onClick, lowestDisplayPercent, labelFontSize, showLabel } = this.props;
    	return <VerticalMiddleContainer style={{paddingTop:10, paddingBottom:10}}>
    		<Pie 
    			ref={(ref)=>{this.chart=ref;}} 
    			data={this.mutateData} 
    			options={{
    				animation:{
    					duration:Metrics.chart.duration
    				},
    				responsive:true,
    				maintainAspectRatio:false,
    				onClick:this.onItemClick,
    				legend:{
    					display:false
    				},
    				plugins: {
    					datalabels: {
    						color: "white",
    						display: (context)=>{
    							var dataset = context.dataset;
    							var value = dataset.data[context.dataIndex];
    							return showLabel && ((value*100) / this.mutateData.sum) >= lowestDisplayPercent;
    						},
    						font: {
    							weight: Metrics.boldFontWeight,
    							size: labelFontSize,
    							family: "Prompt"
    						},
    						formatter: (value, context)=>{
    							return Math.round(value*100 / this.mutateData.sum) + "%";
    						}
    					}
    				}
    			}}/>
    	</VerticalMiddleContainer>;
    }
}

PieChart.defaultProps = {
	data: [],
	labelKey: "item",
	valueKey: "percent",
	hideZero: true,
	showLabel: true,
	labelFontSize: Metrics.fontSize.bold,
	lowestDisplayPercent: 10
};

export default withTheme(PieChart);


// WEBPACK FOOTER //
// ./src/components/chart/PieChart.js